import { render, staticRenderFns } from "./exor-list.vue?vue&type=template&id=452e0408&scoped=true&"
import script from "./exor-list.vue?vue&type=script&lang=js&"
export * from "./exor-list.vue?vue&type=script&lang=js&"
import style0 from "./exor-list.vue?vue&type=style&index=0&id=452e0408&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e0408",
  null
  
)

export default component.exports